export const RANGER_CLASS_CONFIGS = {
  ranger: {
    id: 'ranger',
    name: 'Ranger',
    description: 'Balanced speed, lives, stealth, and melee.',
    lives: 5,
    speedMultiplier: 1,
    detectionMultiplier: 1,
    damageResetMs: 850,
    meleeDamage: 1,
  },
  'ranger-medic': {
    id: 'ranger-medic',
    name: 'Medic',
    description: 'Extra reserve life and faster recovery after damage.',
    lives: 6,
    speedMultiplier: 1,
    detectionMultiplier: 1,
    damageResetMs: 650,
    meleeDamage: 1,
  },
  'ranger-spy': {
    id: 'ranger-spy',
    name: 'Spy',
    description: 'Reduced enemy detection range for stealth approaches.',
    lives: 5,
    speedMultiplier: 1.05,
    detectionMultiplier: 0.74,
    damageResetMs: 850,
    meleeDamage: 1,
  },
  'ranger-heavy': {
    id: 'ranger-heavy',
    name: 'Heavy',
    description: 'More lives and stronger bayonet strikes, but slower movement.',
    lives: 7,
    speedMultiplier: 0.88,
    detectionMultiplier: 1.08,
    damageResetMs: 980,
    meleeDamage: 2,
  },
};

export function getRangerClassConfig(classId = 'ranger') {
  return RANGER_CLASS_CONFIGS[classId] ?? RANGER_CLASS_CONFIGS.ranger;
}
